/* House of Sneakers Startseite: Einblenden beim Scrollen.
   - laeuft nur einmal pro Seite, auch wenn mehrere Sektionen die Datei einbinden
   - bei "Bewegung reduzieren" oder altem Browser passiert nichts (alles sofort sichtbar)
   - was beim Laden schon im Bild ist, wird nie versteckt (kein Flackern) */
(function () {
  if (window.__hosMotion) return;
  window.__hosMotion = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  var SELECTOR = [
    '.hos .hos-head',
    '.hos-trust__item',
    '.hos-tile',
    '.hos-drops__grid > .hos-label',
    '.hos-best__grid > .hos-label',
    '.hos-wa__text',
    '.hos-wa__qr',
    '.hos-review',
    '.hos-check__text',
    '.hos-check__item'
  ].join(',');

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  function setup(root) {
    var perParent = new Map();
    root.querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.classList.contains('hos-reveal')) return;
      var r = el.getBoundingClientRect();
      if (r.width > 0 && r.top < window.innerHeight && r.bottom > 0) return; // schon sichtbar
      var parent = el.parentElement;
      var index = perParent.get(parent) || 0;
      perParent.set(parent, index + 1);
      el.style.setProperty('--hos-delay', Math.min(index, 6) * 70 + 'ms'); // nacheinander einblenden
      el.classList.add('hos-reveal');
      observer.observe(el);
    });
  }

  function init() { setup(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Theme-Editor: neu geladene Sektionen ebenfalls animieren
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
})();
